export default function ArrowRight({ width = 14, height = 9, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0.75 4.25586H12.75'
        stroke='url(#paint0_linear_5242_1741)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.10955 7.76124L12.75 4.25562L9.10955 0.75'
        stroke='url(#paint1_linear_5242_1741)'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5242_1741'
          x1='12.75'
          y1='4.75586'
          x2='0.75'
          y2='4.75586'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5242_1741'
          x1='12.75'
          y1='4.25562'
          x2='9.10955'
          y2='4.25562'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
      </defs>
    </svg>
  );
}
